<template>
  <div class="progressbar-wrapper">
    <div class="progress-item" :class="{'-active': active === 1}" @click="$emit('updateStep', 'stepOne')"><span>1</span></div>
    <div class="progress-item" :class="{'-active': active === 2}" @click="$emit('updateStep', 'stepTwo')"><span>2</span></div>
    <div class="progress-item" :class="{'-active': active === 3, '-small': active === 2 || active === 1}"><span v-if="active === 3">3</span><span v-else ></span></div>
  </div>
</template>

<script>
export default {
  name: 'Progressbar',
  props: {
    active: {
      type: Number,
      default: 1
    }
  }
}
</script>
